module.exports = __webpack_public_path__ + "img/section5_2.906ea7ec.png";